<template>
    <CContainer class="personal-info section" fluid>
        <CRow class="border-bottom">
            <CCol md="10">
                <h2 class="section__title my-4">{{ $t("account_details") }}</h2>
            </CCol>
            <CCol md="2">
                <CButton
                    color="primary"
                    class="button my-4 shadow"
                    size="sm"
                    @click="sendFormAccount"
                >
                    <span class="button__icon">
                        <CSpinner
                            class="mr-1"
                            color="light"
                            size="sm"
                            v-if="forms.account._loading"
                        />
                        <CIcon
                            v-else
                            size="sm"
                            :content="$options.icons.cilSave"
                        />
                    </span>
                    <span class="button__text">{{ $t("save") }}</span>
                </CButton>
            </CCol>
        </CRow>
        <CRow alignHorizontal="center" alignVertical="center" class="mt-4">
            <CCol md="7">
                <CContainer class="personal-info" fluid>
                    <CRow>
                        <CCol col="6">
                            <CInput
                                :label="$t('first_name')"
                                :placeholder="$t('enter_your_first_name')"
                                :isValid="
                                    checkIfFormValid({
                                        formName: 'account',
                                        fieldName: 'ACCOUNT_NAME',
                                    })
                                "
                                :value.sync="
                                    $v.forms.account.ACCOUNT_NAME.$model
                                "
                                :disabled="forms.account._loading"
                            ></CInput>
                        </CCol>
                        <CCol col="6">
                            <CInput
                                :label="$t('last_name')"
                                :placeholder="$t('enter_your_last_name')"
                                :isValid="
                                    checkIfFormValid({
                                        formName: 'account',
                                        fieldName: 'ACCOUNT_SURNAME',
                                    })
                                "
                                :value.sync="
                                    $v.forms.account.ACCOUNT_SURNAME.$model
                                "
                                :disabled="forms.account._loading"
                            ></CInput>
                        </CCol>
                    </CRow>
                    <!-- Email -->
                    <CInput
                        :label="$t('email')"
                        :placeholder="$t('enter_your_email')"
                        :isValid="
                            checkIfFormValid({
                                formName: 'account',
                                fieldName: 'ACCOUNT_EMAIL',
                            })
                        "
                        :value.sync="$v.forms.account.ACCOUNT_EMAIL.$model"
                        :disabled="forms.account._loading"
                    />

                    <!-- Company -->
                    <CInput
                        :label="$t('company')"
                        :placeholder="$t('enter_your_company_name')"
                        :isValid="
                            checkIfFormValid({
                                formName: 'account',
                                fieldName: 'ACCOUNT_COMPANY',
                            })
                        "
                        :value.sync="$v.forms.account.ACCOUNT_COMPANY.$model"
                        :disabled="forms.account._loading"
                    />

                    <!-- Address -->
                    <CInput
                        :label="$t('address')"
                        :placeholder="$t('enter_your_address')"
                        :isValid="
                            checkIfFormValid({
                                formName: 'account',
                                fieldName: 'ACCOUNT_ADDRESS',
                            })
                        "
                        :value.sync="$v.forms.account.ACCOUNT_ADDRESS.$model"
                        :disabled="forms.account._loading"
                    />

                    <!-- Postal code -->
                    <CRow>
                        <CCol sm="12" md="6">
                            <CInput
                                :label="$t('postal_code')"
                                :placeholder="$t('postal_code')"
                                :isValid="
                                    checkIfFormValid({
                                        formName: 'account',
                                        fieldName: 'ACCOUNT_POSTALCODE',
                                    })
                                "
                                :value.sync="
                                    $v.forms.account.ACCOUNT_POSTALCODE.$model
                                "
                                :disabled="forms.account._loading"
                            />
                        </CCol>
                        <CCol sm="12" md="6">
                            <CInput
                                :label="$t('city')"
                                :placeholder="$t('city')"
                                :isValid="
                                    checkIfFormValid({
                                        formName: 'account',
                                        fieldName: 'ACCOUNT_CITY',
                                    })
                                "
                                :value.sync="
                                    $v.forms.account.ACCOUNT_CITY.$model
                                "
                                :disabled="forms.account._loading"
                            />
                        </CCol>
                    </CRow>

                    <!-- Country -->
                    <CRow>
                        <CCol sm="12" md="6">
                            <SelectCountry
                                :label="$t('country') + ':'"
                                :placeholder="$t('select_an_country')"
                                :isValid="
                                    checkIfFormValid({
                                        formName: 'account',
                                        fieldName: 'ACCOUNT_COUNTRY_ID',
                                    })
                                "
                                :value.sync="
                                    $v.forms.account.ACCOUNT_COUNTRY_ID.$model
                                "
                                :disabled="forms.account._loading"
                            />
                        </CCol>
                        <CCol sm="12" md="6">
                            <CInput
                                :label="$t('tax_identification_number') + ':'"
                                prepend="ES"
                                :isValid="
                                    checkIfFormValid({
                                        formName: 'account',
                                        fieldName: 'ACCOUNT_ID',
                                    })
                                "
                                :value.sync="$v.forms.account.ACCOUNT_ID.$model"
                                :disabled="forms.account._loading"
                            />
                        </CCol>
                    </CRow>
                    <!-- Language -->
                    <CRow>
                        <CCol sm="12" md="6">
                            <SelectLanguage
                                :isValid="
                                    checkIfFormValid({
                                        formName: 'account',
                                        fieldName: 'ACCOUNT_LANGUAGE_ID',
                                    })
                                "
                                :value.sync="
                                    $v.forms.account.ACCOUNT_LANGUAGE_ID.$model
                                "
                                :label="$t('language')"
                                :placeholder="$t('select_an_option')"
                                :invalidFeedback="$t('language_is_required')"
                                size="sm"
                            />
                        </CCol>
                        <CCol sm="12" md="6">
                            <CInput
                                :label="$t('code')"
                                :placeholder="$t('code')"
                                :isValid="
                                    checkIfFormValid({
                                        formName: 'account',
                                        fieldName: 'ACCOUNT_CODE',
                                    })
                                "
                                :value.sync="
                                    $v.forms.account.ACCOUNT_CODE.$model
                                "
                                :disabled="true"
                            />
                        </CCol>
                    </CRow>
                </CContainer>
            </CCol>
        </CRow>
    </CContainer>
</template>
<script>
import { cilPencil, cilCaretBottom, cilCaretTop, cilSave } from "@coreui/icons";
import traslateMixin from "@/mixins/traslate.js";
import formMixin from "@/mixins/form.js";

import SelectCountry from "£lement/SelectCountry";
import SelectLanguage from "£lement/SelectLanguage";

import { validationMixin } from "vuelidate";
import { required, numeric } from "vuelidate/lib/validators";

export default {
    name: "AccountManagerTab",
    mixins: [traslateMixin, validationMixin, formMixin],
    icons: {
        cilPencil,
        cilCaretBottom,
        cilCaretTop,
        cilSave,
    },
    components: {
        SelectCountry,
        SelectLanguage,
    },
    data() {
        return {
            forms: {
                account: {
                    ACCOUNT_NAME: null,
                    ACCOUNT_SURNAME: null,
                    ACCOUNT_EMAIL: null,
                    ACCOUNT_COMPANY: null,
                    ACCOUNT_POSTALCODE: null,
                    ACCOUNT_CITY: null,
                    ACCOUNT_COUNTRY_ID: null,
                    ACCOUNT_ADDRESS: null,
                    ACCOUNT_ID: null,
                    ACCOUNT_LANGUAGE_ID: null,
                    ACCOUNT_CODE: null,
                    _loading: false,
                    _matchResponse: "_items",
                },
            },
        };
    },

    validations: {
        forms: {
            account: {
                ACCOUNT_NAME: {
                    required,
                },
                ACCOUNT_SURNAME: {
                    // required
                },
                ACCOUNT_EMAIL: {
                    required,
                },
                ACCOUNT_COMPANY: {
                    // required
                },
                ACCOUNT_POSTALCODE: {
                    // required
                },
                ACCOUNT_CITY: {
                    // required
                },
                ACCOUNT_COUNTRY_ID: {
                    // required
                },
                ACCOUNT_ADDRESS: {
                    // required
                },
                ACCOUNT_ID: {},
                ACCOUNT_LANGUAGE_ID: {},
                ACCOUNT_CODE: {},
            },
        },
    },

    methods: {
        async adapterDataAccountToSend(data) {
            let dataFormat = [];
            for (const key in data) {
                if (Object.hasOwnProperty.call(data, key)) {
                    if (data[key]) {
                        dataFormat.push({
                            name: key,
                            value: data[key],
                        });
                    }
                }
            }
            console.log(dataFormat);
            return dataFormat;
        },

        async loadFormAccount() {
            await this.updateForm({
                formName: "account",
                url: "/identity.api/UpdateAccountData",
            });
        },

        async sendFormAccount() {
            this.forms.account._loading = true;

            await this.sendForm({
                formName: "account",
                url: "/identity.api/UpdateAccountData",
                method: "POST",
                adapterData: this.adapterDataAccountToSend,
            });

            this.forms.account._loading = false;
        },
    },
    async mounted() {
        await this.loadFormAccount();
    },
};
</script>

<style>
</style>